// Import Swiper and required modules
import Swiper from "swiper";
import { Pagination, Navigation, A11y } from "swiper/modules";

// Initialize Swiper and lazy-load charts
const imageSlider = () => {
	const swiper = new Swiper("#image-slider", {
		modules: [Navigation, Pagination, A11y],
		slidesPerView: 1,
		spaceBetween: 30,
		navigation: {
			nextEl: ".slider-arrow--next",
			prevEl: ".slider-arrow--prev",
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: false
		},
	});
};

export default imageSlider;
